import React from 'react';
import { translate } from 'react-i18next';
import { Checkbox, notification } from 'antd';
import i18next from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretRight } from '@fortawesome/pro-solid-svg-icons'
import {
    FETCH_CAMPAIGN_RECIPIENTS_SEARCH_SUCCESS,
    FETCH_TEAM_RECIPIENTS_SEARCH_SUCCESS,
    FETCH_MEMBER_RECIPIENTS_SEARCH_SUCCESS
} from '../../search/searchActions'

import {
    SEND_MESSAGE_SUCCESS
} from '../../messages/messageActions'

import SearchBar from 'Parts/search/SearchBarContainer';
import Wysiwyg from '../../parts/ui/components/fields/Wysiwyg';

import sendMessagePageEN from './locales/SendMessagePage_en.json';
import sendMessagePageFR from './locales/SendMessagePage_fr.json';

import './UserInbox.less';

const RECIPIENTS_PER_BATCH = 12;

class SendMessagePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            all_captains: false,
            send_emails: false,
            send_emails_disabled: false,
            campaignOpen: false,
            teamOpen: false,
            memberOpen: false,
            campaignBatchNumber: 1,
            teamBatchNumber: 1,
            memberBatchNumber: 1,
            campaignRequestDue: true,
            teamRequestDue: true,
            memberRequestDue: true,
            campaignRecipients: [],
            teamRecipients: [],
            memberRecipients: [],
            campaignBottomReached: false,
            teamBottomReached: false,
            memberBottomReached: false,
            selectedTeams: [],
            selectedMembers: []
        }
        
        i18next.addResourceBundle('en', 'SendMessagePage', sendMessagePageEN);
        i18next.addResourceBundle('fr', 'SendMessagePage', sendMessagePageFR);
        
        this.updateCampaignRecipients = this.updateCampaignRecipients.bind(this);
        this.fetchCampaignRecipients = this.fetchCampaignRecipients.bind(this);
        this.updateTeamRecipients = this.updateTeamRecipients.bind(this);
        this.fetchTeamRecipients = this.fetchTeamRecipients.bind(this);
        this.updateMemberRecipients = this.updateMemberRecipients.bind(this);
        this.fetchMemberRecipients = this.fetchMemberRecipients.bind(this);
        this.checkChanged = this.checkChanged.bind(this);
        this.send = this.send.bind(this);
        this.getRecipientsInScope = this.getRecipientsInScope.bind(this);

        const query = new URLSearchParams(props.location.search);

        let defaultCampaign = parseInt(query.get('campaign'));
        let defaultTeam = parseInt(query.get('team'));
        let defaultMember = parseInt(query.get('member'));

        if(Number.isInteger(defaultCampaign) && !isNaN(defaultCampaign)) {
            this.state.campaignRequestDue = false;

            this.fetchCampaignRecipients(1, defaultCampaign, () => {
                if(this.state.campaignRecipients && this.state.campaignRecipients.length > 0) {
                    let campaign = this.state.campaignRecipients[0]
                    this.checkChanged(campaign.id, 'CAMPAIGN')
                    this.setState({campaignOpen: true})
                } else
                    this.state.campaignRequestDue = true;
            });
        } else if(Number.isInteger(defaultTeam) && !isNaN(defaultTeam)) {
            this.state.teamRequestDue = false;

            this.fetchTeamRecipients(1, defaultTeam, () => {
                if(this.state.teamRecipients && this.state.teamRecipients.length > 0) {
                    let team = this.state.teamRecipients[0]
                    this.checkChanged(team.id, 'TEAM', true)
                    this.setState({teamOpen: true})
                } else
                    this.state.teamRequestDue = true;
            });
        } else if(Number.isInteger(defaultMember) && !isNaN(defaultMember)) {
            this.state.memberRequestDue = false;

            this.fetchMemberRecipients(1, defaultMember, () => {
                if(this.state.memberRecipients && this.state.memberRecipients.length > 0) {
                    let member = this.state.memberRecipients[0]
                    this.checkChanged(member.id, 'MEMBER', true)
                    this.setState({memberOpen: true})
                } else
                    this.state.memberRequestDue = true;
            });
        }
    }

    componentDidMount() {
        // This makes it so the recipients are reset every time we switch tabs.
        this.getRecipientsInScope();
    }

    render() {
        const { t, form } = this.props;

        if(this.state.campaignOpen && this.state.campaignRequestDue) {
            this.setState({
                campaignRequestDue: false
            })
            this.fetchCampaignRecipients();
        }

        if(this.state.teamOpen && this.state.teamRequestDue) {
            this.setState({
                teamRequestDue: false
            })
            this.fetchTeamRecipients();
        }

         if(this.state.memberOpen && this.state.memberRequestDue) {
            this.setState({
                memberRequestDue: false
            })
            this.fetchMemberRecipients();
        }

        let recipientArea = [];

        if (this.props.selectedRecipients.length > 0) {
            this.props.selectedRecipients.map((r, i) => {
                if(i > 0)
                    recipientArea.push(<div className="recipient">-</div>);
                recipientArea.push(<div className='recipient'>{"[" + (i + 1) + "] " + r.name}</div>)
            })
        } else
            recipientArea.push(<div className='recipient'>{t('No recipients')}</div>)

        return (
            <div className="SendMessagePage">
                <div className="SendMessagePage__Content">
                    <div className="recipient-list">
                        <div className="checkbox-area">
                            <Checkbox 
                                id={'send_emails'}
                                checked={this.state.send_emails}
                                disabled={this.state.send_emails_disabled}
                                onChange={() => {this.setState({send_emails: !this.state.send_emails})}}
                                className='inbox-checkbox'
                            >{t('SendEmails')}</Checkbox>
                            <Checkbox 
                                id={'all_captains'}
                                checked={this.state.all_captains}
                                disabled={this.state.scope !== undefined && this.state.scope !== 'CAMPAIGN'}
                                onChange={() => {
                                    this.setState({
                                        all_captains: !this.state.all_captains,
                                        campaignBatchNumber: 1,
                                        teamBatchNumber: 1,
                                        memberBatchNumber: 1,
                                        campaignRequestDue: true,
                                        teamRequestDue: true,
                                        memberRequestDue: true
                                    }, () => {
                                        if(this.state.scopeId || this.state.selectedMembers.length > 0 || this.state.selectedTeams.length > 0)
                                            this.getRecipientsInScope();
                                    })
                                }}
                                className='inbox-checkbox'
                            >{t('CaptainsOnly')}</Checkbox>
                        </div>
                        <div>
                            <div className="radio-button-area retractable-section">
                                <FontAwesomeIcon icon={this.state.campaignOpen ? faCaretDown : faCaretRight} className="open-icon" onClick={() => {
                                    let isCampaignOpen = !this.state.campaignOpen;
                                    this.setState({
                                        campaignOpen: isCampaignOpen,
                                    })

                                    if(isCampaignOpen) {
                                        this.setState({
                                            teamOpen: false,
                                            memberOpen: false
                                        })
                                    }
                                }}/>
                                <span>{t('Campaign')}</span>
                            </div>
                            {this.state.campaignOpen && <div className="recipient-area">
                                <SearchBar 
                                    placeholder={t('Search')} 
                                    initialValue={this.props.campaignSearch}
                                    onSearch={(e) => this.fetchCampaignRecipients(1, e.search)}
                                />
                                {this.state.campaignRecipients.length > 0 ? <div className="recipient-list-scroll">{this.state.campaignRecipients.map((r) => {
                                    return (<div>
                                        <input type="radio" id={'campaign_' + r.id} name="campaign" value={r.id} checked={
                                            this.state.scopeId === r.id} onChange={() => {
                                                this.setState({
                                                    teamBatchNumber: 1,
                                                    memberBatchNumber: 1,
                                                    teamRequestDue: true,
                                                    memberRequestDue: true
                                                }, () => {
                                                    this.checkChanged(r.id, 'CAMPAIGN')
                                                })
                                        }}/>
                                        <label className="recipient-label" for={r.id}>{r.name}</label>
                                    </div>)
                                })}
                                <div className="loading-container">
                                    {!this.props.isCampaignRecipientSearchInProgress && !this.state.campaignBottomReached && 
                                        <button className="ant-btn ant-btn-secondary" onClick={() => {
                                                this.fetchCampaignRecipients(this.state.campaignBatchNumber + 1)
                                        }}>
                                            {t('Load More')}
                                        </button>
                                    }
                                </div>
                                </div> : this.props.isCampaignRecipientSearchInProgress ? 
                                    <div className='loading-container'><div className="loading-indicator local"><span>.</span><span>.</span><span>.</span></div></div> 
                                    : <span className='recipient-list-scroll'>{t('No valid results')}</span>}
                                 {this.props.isCampaignRecipientSearchInProgress && this.state.campaignRecipients.length > 0 &&
                                    <div className='loading-container'><div className="loading-indicator local"><span>.</span><span>.</span><span>.</span></div></div>}
                            </div>}
                            <div className="radio-button-area retractable-section">
                                <FontAwesomeIcon icon={this.state.teamOpen ? faCaretDown : faCaretRight} className="open-icon" onClick={() => {
                                    let isTeamOpen = !this.state.teamOpen;
                                    this.setState({
                                        teamOpen: isTeamOpen,
                                    })

                                    if(isTeamOpen) {
                                        this.setState({
                                            campaignOpen: false,
                                            memberOpen: false
                                        })
                                    }
                                }}/>
                                <span>{t('Team')}</span>
                            </div>
                            {this.state.teamOpen && <div className="recipient-area">
                                <SearchBar 
                                    placeholder={t('Search')} 
                                    initialValue={this.props.teamSearch}
                                    onSearch={(e) => this.fetchTeamRecipients(1, e.search)}
                                />
                                {this.state.teamRecipients.length > 0 ? <div className="recipient-list-scroll">{this.state.teamRecipients.map((r) => {
                                    return (<div>
                                        <Checkbox id={'team_' + r.id} name="team" checked={this.state.selectedTeams.find(t => t === r.id) !== undefined} 
                                        onChange={(e) => {
                                            this.setState({
                                                memberBatchNumber: 1,
                                                memberRequestDue: true
                                            }, () => {
                                                this.checkChanged(r.id, 'TEAM', e.target.checked)
                                            });
                                        }}>{r.name}</Checkbox>
                                    </div>)
                                })}
                                <div className="loading-container">
                                    {!this.props.isTeamRecipientSearchInProgress && !this.state.teamBottomReached && 
                                        <button className="ant-btn ant-btn-secondary" onClick={() => {
                                                this.fetchTeamRecipients(this.state.teamBatchNumber + 1)
                                        }}>
                                            {t('Load More')}
                                        </button>
                                    }
                                </div>
                                </div> : this.props.isTeamRecipientSearchInProgress ? 
                                    <div className='loading-container'><div className="loading-indicator local"><span>.</span><span>.</span><span>.</span></div></div> 
                                    : <span className='recipient-list-scroll'>{t('No valid results')}</span>}
                                {this.props.isTeamRecipientSearchInProgress && this.state.teamRecipients.length > 0 &&
                                    <div className='loading-container'><div className="loading-indicator local"><span>.</span><span>.</span><span>.</span></div></div>}
                            </div>}
                            <div className="radio-button-area retractable-section">
                                <FontAwesomeIcon icon={this.state.memberOpen ? faCaretDown : faCaretRight} className="open-icon" onClick={() => {
                                    let isMemberOpen = !this.state.memberOpen;
                                    this.setState({
                                        memberOpen: isMemberOpen,
                                    })

                                    if(isMemberOpen) {
                                        this.setState({
                                            teamOpen: false,
                                            campaignOpen: false
                                        })
                                    }
                                }}/>
                                <span>{t('Members')}</span>
                            </div>
                            {this.state.memberOpen && <div className="recipient-area">
                                <SearchBar 
                                    placeholder={t('Search')} 
                                    initialValue={this.props.memberSearch}
                                    onSearch={(e) => this.fetchMemberRecipients(1, e.search)}
                                />
                                {this.state.memberRecipients.length > 0 ? <div className="recipient-list-scroll">{this.state.memberRecipients.map((r) => {
                                    return (<Checkbox
                                        id={'member_' + r.id}
                                        checked={this.state.selectedMembers.find(m => m === r.id) !== undefined}
                                        onChange={(e) => {
                                            this.checkChanged(r.id, 'MEMBER', e.target.checked)
                                        }}
                                        className='inbox-checkbox'
                                    >{r.name}</Checkbox>)
                                })}
                                <div>
                                    {!this.props.isMemberRecipientSearchInProgress && !this.state.memberBottomReached && 
                                        <button className="ant-btn ant-btn-secondary" onClick={() => {
                                                this.fetchMemberRecipients(this.state.memberBatchNumber + 1)
                                        }}>
                                            {t('Load More')}
                                        </button>
                                    }
                                </div>
                                </div> : this.props.isMemberRecipientSearchInProgress ? 
                                    <div className='loading-container'><div className="loading-indicator local"><span>.</span><span>.</span><span>.</span></div></div> 
                                    : <span className='recipient-list-scroll'>{t('No valid results')}</span>}
                                {this.props.isMemberRecipientSearchInProgress && this.state.memberRecipients.length > 0 &&
                                    <div className='loading-container'><div className="loading-indicator local"><span>.</span><span>.</span><span>.</span></div></div>}
                            </div>}
                        </div>
                    </div>
                    <div className="send-message-area">
                        <input id="msg-subject" className="ant-input" placeholder={t('Subject Placeholder')} value={this.state.subject} onChange={(e) => {
                            this.setState({ subject: e.target.value});
                        }}/>
                        <Wysiwyg 
                            fieldId="txt-content" 
                            className="message-content" 
                            onChange={(e) => {this.wysiwygContent = e}}
                            maxlength={2048}
                            required={true}
                            accentColors={this.props.accentColors}
                            form={form}
                            allowAllTags={true}
                        />
                        <div>
                            <button className={'ant-btn ant-btn-primary'} onClick={() => {this.send(false)}}>{t('Send')}</button>
                            <button className={'ant-btn ant-btn-secondary secondary'} onClick={() => {this.send(true)}}>{t('Save as draft')}</button>
                        </div>
                        <div className="recipient-zone">
                            <b>{t("Recipient List", { count: this.props.selectedRecipients.length })}</b>
                            <div className='recipient-area flex'>{recipientArea}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    updateCampaignRecipients(callback = null) {
        if (this.props.campaignBatchNumber > this.state.campaignBatchNumber) {
            this.setState({
                campaignRecipients: this.state.campaignRecipients.concat(this.props.campaignRecipients),
                campaignBatchNumber: this.props.campaignBatchNumber,
                campaignBottomReached: this.props.campaignRecipients.length < RECIPIENTS_PER_BATCH
            }, callback)
        } else {
            this.setState({
                campaignRecipients: this.props.campaignRecipients,
                campaignBatchNumber: this.props.campaignBatchNumber,
                campaignBottomReached: this.props.campaignRecipients.length < RECIPIENTS_PER_BATCH
            }, callback);
        }
    }

    fetchCampaignRecipients(batchNumber = this.state.campaignBatchNumber, search = this.props.campaignSearch, callback = null) {
        this.props.searchCampaignRecipients(this.props.platformId, search, batchNumber, this.state.all_captains).then((e) => {
            if(e.type === FETCH_CAMPAIGN_RECIPIENTS_SEARCH_SUCCESS) {
                this.updateCampaignRecipients(callback);
            }
        })
    }

    updateTeamRecipients(callback = null) {
        if (this.props.teamBatchNumber > this.state.teamBatchNumber) {
            this.setState({
                teamRecipients: this.state.teamRecipients.concat(this.props.teamRecipients),
                teamBatchNumber: this.props.teamBatchNumber,
                teamBottomReached: this.props.teamRecipients.length < RECIPIENTS_PER_BATCH
            }, callback)
        } else {
            this.setState({
                teamRecipients: this.props.teamRecipients,
                teamBatchNumber: this.props.teamBatchNumber,
                teamBottomReached: this.props.teamRecipients.length < RECIPIENTS_PER_BATCH
            }, callback);
        }
    }

    fetchTeamRecipients(batchNumber = this.state.teamBatchNumber, search = this.props.teamSearch, callback = null) {
        this.props.searchTeamRecipients(this.props.platformId, this.state.scopeId, search, batchNumber).then((e) => {
            if(e.type === FETCH_TEAM_RECIPIENTS_SEARCH_SUCCESS) {
                this.updateTeamRecipients(callback);
            }
        })
    }

    updateMemberRecipients(callback = null) {
        if (this.props.memberBatchNumber > this.state.memberBatchNumber) {
            this.setState({
                memberRecipients: this.state.memberRecipients.concat(this.props.memberRecipients),
                memberBatchNumber: this.props.memberBatchNumber,
                memberBottomReached: this.props.memberRecipients.length < RECIPIENTS_PER_BATCH
            }, callback)
        } else {
            this.setState({
                memberRecipients: this.props.memberRecipients,
                memberBatchNumber: this.props.memberBatchNumber,
                memberBottomReached: this.props.memberRecipients.length < RECIPIENTS_PER_BATCH
            }, callback);
        }
    }

    fetchMemberRecipients(batchNumber = this.state.memberBatchNumber, search = this.props.memberSearch, callback = null) {
        this.props.searchMemberRecipients(this.props.platformId, this.state.scopeId, this.state.selectedTeams, search, batchNumber, this.state.all_captains).then((e) => {
            if(e.type === FETCH_MEMBER_RECIPIENTS_SEARCH_SUCCESS) {
                this.updateMemberRecipients(callback);
            }
        })
    }

    checkChanged(id, scope, checked) {
        if (scope === 'MEMBER') {
            this.setState({
                selectedMembers: checked ? [...this.state.selectedMembers, this.props.memberRecipients.find(m => m.id === id).id] : 
                this.state.selectedMembers.filter(m => m !== id)
            }, this.getRecipientsInScope)
        } else if (scope === 'CAMPAIGN') {
            this.setState({
                selectedMembers: [],
                selectedTeams: [],
                scopeId: id,
            }, this.getRecipientsInScope)
        } else if (scope === 'TEAM') {
            this.setState({
                selectedTeams: checked ? [...this.state.selectedTeams, this.props.teamRecipients.find(t => t.id === id).id] : 
                this.state.selectedTeams.filter(t => t !== id)
            }, this.getRecipientsInScope)
        }
    }

    getRecipientsInScope() {
        this.props.getMembersInScope(this.props.platformId, this.state.scopeId, this.state.selectedTeams, this.state.selectedMembers, this.state.all_captains);
    }

    send(draft = false) {
        if(this.props.isSendMessageInProgress) {
            return notification.error({
                message: this.props.t('Message already in progress'),
                description: this.props.t('Message already being sent')
            })
        }

        let formValues = {
            content: this.wysiwygContent, 
            subject: this.state.subject, 
            draft: draft, 
            send_emails: this.state.send_emails,
            recipients: this.props.selectedRecipients.map((r) => r.id)
        };
        
        if(!this.state.subject || this.state.subject.length < 1) {
            return notification.error({
                message: this.props.t('Missing subject'),
                description: this.props.t('Please give a subject')
            })
        } else if(!this.wysiwygContent || this.wysiwygContent.length < 1) {
            return notification.error({
                message: this.props.t('Missing content'),
                description: this.props.t('Please give content to your message')
            })
        }
        else if(this.state.send_emails && formValues.draft) {
            return notification.error({
                message: this.props.t('Cannot send emails with draft'),
                description: this.props.t('No email notifications with draft')
            })
        } else if (formValues.recipients.length < 1) {
            return notification.error({
                message: this.props.t('Missing recipients'),
                description: this.props.t('Please choose recipients for your message')
            })
        }

        this.props.sendMessage(formValues, this.props.platformId).then((e) => {
            if(e.type === SEND_MESSAGE_SUCCESS) {
                this.props.history.push(`/${this.props.locale}/d/messages/inbox`);
            }
        });
    }
}
export default translate('SendMessagePage')(SendMessagePage);